module.exports = __webpack_public_path__ + "img/home3.f1485ad3.jpg";